{
  "signIn": {
    "title": "Log masuk",
    "subtitle": "Teruskan ke projek anda.",
    "email": "Alamat e-mel",
    "password": "Kata laluan",
    "remember": "Kekalkan saya log masuk",
    "rememberHint": "Kekal log masuk selama 30 hari pada peranti ini.",
    "submit": "Log masuk",
    "submitting": "Sedang log masuk",
    "forgot": "Lupa kata laluan anda?",
    "noAccount": "Tiada akaun?",
    "createAccount": "Cipta satu",
    "google": "Teruskan dengan Google",
    "or": "atau"
  },
  "signUp": {
    "title": "Cipta akaun",
    "subtitle": "Mulakan organisasi percubaan, atau terima jemputan.",
    "name": "Nama penuh",
    "email": "Alamat e-mel",
    "password": "Kata laluan",
    "passwordHint": "Sekurang-kurangnya 12 aksara. Elakkan kata laluan yang anda guna di tempat lain.",
    "submit": "Cipta akaun",
    "submitting": "Sedang mencipta akaun anda",
    "haveAccount": "Sudah ada akaun?",
    "signIn": "Log masuk"
  },
  "forgotPassword": {
    "title": "Tetapkan semula kata laluan anda",
    "subtitle": "Kami akan menghantar e-mel berisi pautan untuk memilih kata laluan baharu.",
    "backToSignIn": "Kembali ke log masuk",
    "email": "Alamat e-mel",
    "submit": "Hantar pautan kepada saya",
    "submitting": "Sedang menghantar",
    "sent": {
      "title": "Semak e-mel anda",
      "description": "Jika ada akaun menggunakan alamat itu, pautan untuk memilih kata laluan baharu sedang dihantar. Ia tamat tempoh dalam 60 minit dan boleh digunakan sekali sahaja."
    }
  },
  "resetPassword": {
    "title": "Pilih kata laluan baharu",
    "subtitle": "Pautan yang anda ikuti membolehkan anda menetapkan kata laluan baharu sekali sahaja.",
    "password": "Kata laluan baharu",
    "submit": "Tetapkan kata laluan baharu",
    "submitting": "Sedang menyimpan",
    "missingToken": {
      "title": "Pautan ini tidak lengkap",
      "description": "Buka semula pautan daripada e-mel, atau minta pautan baharu."
    },
    "done": {
      "title": "Kata laluan telah ditukar",
      "description": "Log masuk dengan kata laluan baharu anda."
    }
  },
  "verifyEmail": {
    "title": "Sahkan e-mel anda",
    "subtitle": "Sahkan alamat anda sebelum menjalankan analisis.",
    "verified": {
      "title": "E-mel disahkan",
      "description": "Alamat anda telah disahkan. Anda boleh menjalankan analisis sekarang."
    },
    "pending": {
      "title": "Sahkan e-mel anda",
      "description": "Kami telah menghantar pautan ke alamat anda. Ikuti pautan itu untuk melengkapkan penyediaan akaun."
    },
    "invalid": {
      "title": "Pautan ini tidak lagi berfungsi",
      "description": "Ia telah tamat tempoh, atau alamat pada akaun berubah selepas ia dihantar. Hantar pautan baharu kepada diri anda."
    },
    "resend": "Hantar pautan baharu",
    "resending": "Sedang menghantar",
    "resent": "Pautan baharu sedang dihantar.",
    "alreadyVerified": "Alamat itu telah pun disahkan.",
    "continue": "Pergi ke projek anda"
  },
  "validation": {
    "emailRequired": "Masukkan alamat e-mel anda",
    "emailInvalid": "Masukkan alamat e-mel yang sah",
    "passwordRequired": "Masukkan kata laluan anda",
    "nameRequired": "Masukkan nama anda",
    "passwordTooShort": "Gunakan sekurang-kurangnya 12 aksara"
  }
}
